import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export function useUnreadMessageCount() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["unread-messages", user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;

      // Count unread messages across the user's THREADS.
      // This previously filtered on messages.connection_id, which is NULL for
      // every row in the table (all 229 messages are thread-based), so the count
      // was permanently 0.
      const { data: threads, error: threadError } = await supabase
        .from("message_threads")
        .select("id")
        .or(`participant_1_id.eq.${user.id},participant_2_id.eq.${user.id}`);

      if (threadError) throw threadError;
      if (!threads || threads.length === 0) return 0;

      const threadIds = threads.map((t) => t.id);

      // Count unread messages where the user is NOT the sender
      const { count, error } = await supabase
        .from("messages")
        .select("*", { count: "exact", head: true })
        .in("thread_id", threadIds)
        .neq("sender_id", user.id)
        .is("read_at", null);

      if (error) throw error;
      return count || 0;
    },
    enabled: !!user?.id,
    refetchInterval: 30000, // Refetch every 30 seconds
  });
}
